import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
import Button from "./ButtonRed";
import VerticalPixelImage from "./VerticalPixelImage";
import generateOwnMoneyIcon from "../images/generate-own-money-icon.svg"
import digitalHiringIcon from "../images/digital-hiring-icon.svg"
import specialConditionsIcon from "../images/special-conditions-icon.svg"
import minimumAmountIcon from "../images/minimum-amount-icon.svg"


export default function GradientSection(props) {
    return (
        <div className="generate-money-container gradient">
            <div style={{ height: "100px", overflow: "hidden" }}>
                <svg
                    viewBox="0 0 500 100"
                    preserveAspectRatio="none"
                    style={{ height: "100%", width: "100%" }}
                >
                    <path
                        d="M-1.97,28.13 C149.99,150.00 271.49,-49.98 500.00,49.98 L500.00,0.00 L0.00,0.00 Z"
                        style={{ stroke: "none", fill: "#fff" }}
                    ></path>
                </svg>
            </div>
            <Container className="mt-2 mt-lg-5">
                <Row>
                    <Col className="d-none d-lg-flex" lg={2}>
                        <VerticalPixelImage />
                    </Col>
                    <Col lg={8}>
                        <Row>
                            <Col xs={12} lg={{ span: 10, offset: 1 }}>
                                <Row className="m-lg-0 p-lg-0">
                                    <Col className="d-lg-none ps-0" xs={2}>
                                        <VerticalPixelImage />
                                    </Col>
                                    <Col className="m-lg-0 p-lg-0 justify-content-lg-center" xs={8} lg={12}>
                                        <h2 className="generate-money-title text-primary text-center fw-bold mb-5">{props.title} <span className="text-danger">{props.titleBold}</span></h2>
                                    </Col>
                                    <Col className="d-flex d-lg-none justify-content-end pe-0" xs={2}>
                                        <VerticalPixelImage />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="d-none d-lg-flex justify-content-start mt-3" lg={4}>
                                <img
                                    className="generate-own-money-icon"
                                    src={generateOwnMoneyIcon}
                                    alt="generar-dinero"
                                />
                            </Col>
                            <Col xs={12} lg={8}>
                                <Row className="mb-lg-4">
                                    <Col className="mb-4 mb-lg-0" xs={12} lg={6}>
                                        <div className="d-flex justify-content-center justify-content-lg-start">
                                            <img
                                                className="digital-hiring-icon mb-3"
                                                src={digitalHiringIcon}
                                                alt="Contratación-100%-digital"
                                            />
                                        </div>
                                        <p className="text-description text-center text-lg-start px-5 px-lg-0"><span className="fw-bold">{props.descriptionBoldFirst} </span>
                                        {props.descriptionFirst} <span className="fw-bold">{props.descriptionBoldFirstTwo}</span> {props.descriptionFirstTwo}</p>
                                    </Col>
                                    <Col className="mb-4 mb-lg-0" lg={6}>
                                        <div className="d-flex justify-content-center justify-content-lg-start">
                                            <img
                                                className="special-conditions-icon mb-3"
                                                src={specialConditionsIcon}
                                                alt="condiciones-negociadas"
                                            />
                                        </div>
                                        <p className="text-description text-center text-lg-start px-5 px-lg-0">{props.descriptionSecond} <span className="fw-bold">{props.descriptionSecondBold}</span></p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="mb-4 mb-lg-0" lg={6}>
                                        <div className="d-flex justify-content-center justify-content-lg-start">
                                            <img
                                                className="minimum-amount-icon mb-3"
                                                src={minimumAmountIcon}
                                                alt="montos-apertura"
                                            />
                                        </div>
                                        <p className="text-description text-center text-lg-start px-5 px-lg-0">{props.descriptionThird} <span className="fw-bold">{props.descriptionThirdBold}</span></p>
                                    </Col>
                                    <Col className="mb-4 mb-lg-0" lg={6}>
                                        <div className="d-flex justify-content-center justify-content-lg-start">
                                            <img
                                                className="digital-hiring-icon mb-3"
                                                src={digitalHiringIcon}
                                                alt="administrar"
                                            />
                                        </div>
                                        <p className="text-description text-center text-lg-start px-5 px-lg-0">{props.descriptionFourth} <span className="fw-bold">{props.descriptionFourthBold}</span> {props.descriptionFourthTwo}</p>
                                    </Col>
                                </Row>
                                <div className="d-flex justify-content-center justify-content-lg-start mt-lg-5 mb-5">
                                    <Button title="ÚNETE A SOWOS" href={`${process.env.GATSBY_APP_URL}/sign-up`} />
                                </div>
                                <div className="d-flex">
                                    <p className="infos-content mb-0">{props.infoFirst} <br/><br/> {props.infoSecond}</p>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col className="d-none d-lg-flex justify-content-end" lg={2}>
                        <VerticalPixelImage />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}
